import { render, staticRenderFns } from "./ProspectFormulaire.vue?vue&type=template&id=5ef2d9e8"
import script from "./ProspectFormulaire.vue?vue&type=script&lang=ts"
export * from "./ProspectFormulaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports